import { modalsMentorshipsRepository } from '@/repositories'

function useListModals() {
	const { data, isLoading, isSuccess, refetch } =
		modalsMentorshipsRepository.useListQuery(undefined, {
			refetchOnMountOrArgChange: true,
		})

	return { data, isLoading, isSuccess, refetch }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	list: useListModals,
}
